import {
  Shield, Car, HardHat, Building2, ShoppingBag, CalendarCheck, Bell, Warehouse, HeartPulse,
  Home, Star, Cctv, Flame, TrafficCone, KeyRound, AlertTriangle, GraduationCap, Hotel, Truck,
  ClipboardCheck, Newspaper,
} from "lucide-react";

export const SERVICE_ICONS = {
  "uniformed-security-guards": Shield,
  "mobile-security-patrol": Car,
  "construction-site-security": HardHat,
  "commercial-office-security": Building2,
  "retail-loss-prevention": ShoppingBag,
  "event-security": CalendarCheck,
  "concierge-front-desk-security": Bell,
  "industrial-warehouse-security": Warehouse,
  "healthcare-facility-security": HeartPulse,
  "residential-condo-security": Home,
  "vip-executive-protection": Star,
  "cctv-remote-monitoring": Cctv,
  "fire-watch-security": Flame,
  "traffic-control-parking-enforcement": TrafficCone,
  "alarm-response-keyholding": KeyRound,
  "crisis-strike-security": AlertTriangle,
  "school-campus-security": GraduationCap,
  "hotel-hospitality-security": Hotel,
  "logistics-transport-escort": Truck,
  "security-risk-assessment": ClipboardCheck,
};

export const SECTOR_ICONS = {
  "construction-development": HardHat,
  "commercial-real-estate": Building2,
  "retail-shopping-centres": ShoppingBag,
  healthcare: HeartPulse,
  "education-campuses": GraduationCap,
  "hospitality-hotels": Hotel,
  "industrial-warehousing": Warehouse,
  "residential-property-management": Home,
  "events-entertainment": CalendarCheck,
  "transportation-logistics": Truck,
};

export const INSIGHT_ICON = Newspaper;

const gridStyle = {
  backgroundImage:
    "linear-gradient(rgba(255,255,255,.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.4) 1px, transparent 1px)",
  backgroundSize: "40px 40px",
};

export const IconTile = ({ icon: Icon, size = "h-10 w-10", className = "" }) => (
  <div className={`relative flex items-center justify-center bg-[#131620] overflow-hidden ${className}`}>
    <div className="absolute inset-0 opacity-[0.07]" style={gridStyle} />
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,85,0,0.12),transparent_70%)]" />
    <Icon className={`${size} text-[#FF5500] relative`} strokeWidth={1.25} />
  </div>
);
